import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./utility/useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";
import RuvnlSimulationIndex from "./SimulateProcurement/SimulationIndex";
import { getProcurementGridcoSession } from "../../../Rest_api/RestApi";
import { setOptimizerGridcoDateRange } from "../../../store/state/ProcurementOptimizer/GridcoOptimizer/OptimizerDate";
import { setOptimizerGridcoSession } from "../../../store/state/ProcurementOptimizer/GridcoOptimizer/OptimizerSession";
import { setOptimizerGridcoSessionToken } from "../../../store/state/ProcurementOptimizer/GridcoOptimizer/OptimizerSessionToken";
import { useDispatch } from "react-redux";
import PowerIndex from "./PowerProcurement/PowerIndex";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerGridcoSession() {
      const data = await getProcurementGridcoSession();
      if (data) {
        dispatch(
          setOptimizerGridcoDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          })
        );
        dispatch(setOptimizerGridcoSession(data.session));
        dispatch(setOptimizerGridcoSessionToken(data.session_token));
      }
    }
    OptimizerGridcoSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "power":
        return <PowerIndex />;
      case "simulation":
        return <RuvnlSimulationIndex />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
